module.exports = __webpack_public_path__ + "img/vip-icon-6.d82462ee.png";